export default "__VITE_ASSET__b253cd01__"